export default __webpack_public_path__ + "static/articulo5-d5df027f18b86bbbb84e52c61aa0a21b.png";